module.exports = __webpack_public_path__ + "static/media/bottom.3297ec43.jpg";